export const iconFontAwesomeSecurityExplosion = (
	<i className="fa-solid fa-explosion"></i>
);
